import { render, staticRenderFns } from "./fccPublicacoesTVisualizacao.vue?vue&type=template&id=dfb59adc"
import script from "./fccPublicacoesTVisualizacao.vue?vue&type=script&lang=js"
export * from "./fccPublicacoesTVisualizacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports